import useStore from '../../store/store';
import { Container, Row, Col } from "react-grid-system";

const roundValue = (value) => {
	return +(Math.round(value + "e+1") + "e-1");
}

const SoundPowerDB = (
	{
		setinitialSourceSoundPower,
		initialSourceSoundPower,
		RecieverNoiseLevel,
		receiverSPLNoBarrier,
	}
) => {
	const barrierScenario = useStore((state) => state.scenario);
	if (barrierScenario === 'noBarriers') {
		RecieverNoiseLevel = '';
	}
	else {
		RecieverNoiseLevel = roundValue(RecieverNoiseLevel);
	}
	return (
		<>
			<div class="panel" id="soundPowerDBPanel" style={{ height: '100%' }}>
				<Container>
					<Row style={{ justifyContent: 'center' }}>
						<Col xs={12} style={{ marginBottom: '20px' }}>
							<label className="panel-number" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'row', width: '100%' }}>
								Source sound power
								<label className="panel-number" style={{ display: 'flex', flexFlow: 'row' }} >
									<input style={{ marginTop: '0px', }} className="inner-panel-boxed-input user-input" type='text' onChange={(e) => { setinitialSourceSoundPower(e.target.value) }} value={initialSourceSoundPower}  ></input>dB(A)
								</label>
							</label>
						</Col>
						<div class="panel-bold-title">Receiver noise level</div>
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '5px' }}>
							No barrier
							<div className="output" style={{ marginTop: '0px' }}>
								{roundValue(receiverSPLNoBarrier)}
							</div>
							dB(A)
						</div>
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '15px' }}>
							With barrier
							<div className="output" style={{ marginTop: '0px' }}> {RecieverNoiseLevel}</div>
							dB(A)
						</div>
					</Row>
				</Container>
			</div>
		</>
	)
}

export default SoundPowerDB;